// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxView_checkbox__U292Y","options":"CheckboxView_options__P-Oak","option":"CheckboxView_option__+AcYW"};